<template>
  <div class="menu_container">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回上一层" @click="backIndex"/>
      水质管理
    </div>
    <!-- 菜单容器 -->
    <div class="menuBox">
      <div class="boxList box01" @click="jumpIn(1)">
        <img src="./img/water.png" alt="水源水、出厂水">
        <p>水源水、出厂水</p>
      </div>
      <div class="boxList box02" @click="jumpIn(2)">
        <img src="./img/water.png" alt="生产流程水">
        <p>生产流程水</p>
      </div>
      <div class="boxList box03" @click="jumpIn(3)">
        <img src="./img/water.png" alt="管网水">
        <p>管网水</p>
      </div>
      <div class="boxList box04" @click="jumpIn(4)">
        <img src="./img/water.png" alt="次氯酸钠">
        <p>次氯酸钠</p>
      </div>
      <div class="boxList box05" @click="jumpIn(5)">
        <img src="./img/water.png" alt="聚合氯化铝">
        <p>聚合氯化铝</p>
      </div>
      <div class="boxList box06" @click="jumpIn(6)">
        <img src="./img/water.png" alt="管网冲洗水质验收">
        <p>管网冲洗水质验收</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return{
      popstateLock: 0,//是否监听物理返回键
    }
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate()
      }else{
        this.removePopstate()
      }
    }
  },
  mounted() {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
  },
  destroyed(){
    this.removePopstate()
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //把导航路由辨别码转成整形
      if (!this.id) {
        //在没有传id的情况下，就是在系统首页，这个时候调用微信WeixinJSBridgeReady自带的API对返回键进行监听实现在首页返回关闭页面
        document.addEventListener("WeixinJSBridgeReady", function() {
          window.WeixinJSBridge.call("closeWindow");
        }, false);
        window.WeixinJSBridge.call("closeWindow");
      } else {
        //判断物理返回键是否监听
        if (!this.popstateLock) {
          window.history.pushState(null, null, '#')
        }
      }
    },
    //返回水质管理页面
    backIndex() {
      this.$router.replace({name: 'hyPage'});
    },
    // 跳转路由
    jumpIn(type) {
      switch (type) {
        case 1:
          this.$router.replace({ name: "sysQuery" });
          break;
        case 2:
          this.$router.replace({ name: "sclcsQuery" });
          break;
        case 3:
          this.$router.replace({ name: "gwsQuery" });
          break;
        case 4:
          this.$router.replace({ name: "clsnQuery" });
          break;
        case 5:
          this.$router.replace({ name: "jhlhlQuery" });
          break;
        case 6:
          this.$router.replace({ name: "gwcxszQuery" });
          break;
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.menu_container {
  font-size: 16px;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  .headLine {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #fff;
    height: 50px;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 99;
    border-bottom: 1px #efefef solid;

    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .menuBox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 70px 20px 20px;
    .boxList {
      display: flex;
      flex-direction: column;
      width: 45%;
      border-radius: 6px;
      text-align: center;
      margin-bottom: 20px;
      padding: 0 0 25px;
      position: relative;
      img {
        margin: 20px auto;
        height: 60px;
      }
      p {
        display: block;
        color: #F3F8F3;
        padding: 0;
        margin: 0;
        text-align: center;
        font-size: 18px;
        font-weight: 600;
      }
    }
    .box01 {
      background-color: #36AB60;
    }
    .box02 {
      background-color: #E98F36;
    }
    .box03 {
      background-color: #D81E06;
    }
    .box04 {
      background-color: #A4579D;
    }
    .box05 {
      background-color: #1195DB;
    }
    .box06 {
      background-color: #d0c605;
    }
    .box07 {
      background-color: #d0c605;
    }
  }
}
</style>
